import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onChunkClick: () => void;
};

export const GetReviewChunkBanner = ({ onChunkClick }: Props) => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  const handleClick = () => {
    setDismissed(true);
    onChunkClick();
  };

  return (
    <div className='flex items-center justify-center'>
      <div className='m-2 flex w-full max-w-[1240px] flex-col items-start justify-center gap-2 rounded-lg border-2 border-primary bg-[#F6F6FE] p-2 md:flex-row md:items-center md:gap-6 lg:gap-10 lg:p-4 lgXl:gap-12'>
        <div className='flex flex-1 flex-col gap-2 lg:flex-row lg:items-center lg:gap-10'>
          <div className='inline-flex flex-nowrap items-center justify-start gap-2'>
            <InfoOutlinedIcon
              style={{ fill: '#3032DC' }}
              className='inline-block h-6 min-h-[24px] w-6 min-w-[24px] align-middle'
            />
            <h5 className='heading-100 whitespace-nowrap text-primary md:text-lg md:leading-[19.2px]'>
              {t('get.chunk_banner_title')}
            </h5>
          </div>
          <p className='flex-1 text-200 text-sm leading-[22.4px] md:text-base md:leading-[25.6px]'>
            {t('get.chunk_banner_text')}
          </p>
        </div>
        <button
          onClick={handleClick}
          className='button-secondary h-12 w-full max-w-[360px] self-center whitespace-nowrap md:w-fit'
        >
          {t('get.chunk_banner_btn')}
        </button>
      </div>
    </div>
  );
};
